<template>
  <wo-card :title="modalTitle">
    <wo-region>
      <wo-layout>
        <wo-typography>{{ modalMessage }}</wo-typography>
        <po-error-display :value="error" />
        <slot>
        </slot>
      </wo-layout>
    </wo-region>
    <wo-layout>
      <po-confirmation-buttons :valid="valid" v-focus="focusConfirm" @confirm="confirmed" @cancel="dismiss" labelKey="general.action.confirm" />
    </wo-layout>
  </wo-card>
</template>
<script>

import modal from '@/mixins/modal'

export default {
  mixins: [modal],
  props: {
    titleKey: { type: String, default: 'general.confirmTitle' },
    title: String,
    messageKey: String,
    message: String,
    confirm: Function,
    focusConfirm: Boolean,
    valid: { type: Boolean, default: true }
  },
  data () {
    return {
      error: undefined
    }
  },
  computed: {
    modalTitle () {
      return this.title || this.$t(this.titleKey)
    },
    modalMessage () {
      return this.message || this.$t(this.messageKey)
    }
  },
  methods: {
    confirmed ({ detail }) {
      if (this.confirm) {
        const result = this.confirm()
        if (result) {
          Promise.resolve(result)
            .then(this.close, this.failed)
            .finally(detail.resolve)
        } else {
          detail.resolve()
        }
      } else {
        this.close()
      }
    },
    failed (error) {
      this.error = error
    }
  }
}
</script>
